<template>
    <div>
      <input
      :type="type"
      :lang="type === 'number' ? 'en' : undefined"
      :name="name"
      :min="min"
      :max="max"
      :class="{'error': error, 'success': success, 'disabled': disabled, }"
      :disabled="disabled"
      :value="value"
      @keyup.enter="$emit('enter')"
      @input="onInput($event)"
      class='form-control'
      :style="{ fontSize: fontSize ? fontSize + 'px' : null }"
      :placeholder="placeholder">
    </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    type: String,
    value: {
      type: [String, Number],
      required: false
    },
    fontSize: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    success: {
      type: Boolean,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    min: {
      type: String,
      required: false
    },
    max: {
      type: String,
      required: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    onInput (e) {
      let val = e.target.value
      if (this.type === 'number') {
        val = val.replace(/,/g, '.')
      }
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
.error {
  border-color: red !important;
}
.success {
  border-color: #58d858 !important;
}
.disabled {
  border-color: rgb(155, 155, 155);
  background-color: rgb(214, 214, 214);
}
</style>
